import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Forbidden = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(15);

  useEffect(() => {
    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-800 via-gray-700 to-gray-900">
      <div className="text-center px-4">
        {/* Lock Icon */}
        <div className="mb-8">
          <div className="w-64 h-64 mx-auto relative">
            {/* Animated Lock Icon */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-bounce">
                <svg 
                  className="w-32 h-32 text-yellow-400" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" 
                  />
                </svg>
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center mt-32">
              <h1 className="text-9xl font-bold text-white drop-shadow-2xl">
                403
              </h1>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 max-w-md mx-auto border border-white/20 shadow-2xl">
          <h2 className="text-3xl font-bold text-white mb-4">
            Access Denied
          </h2>
          <p className="text-white/90 text-lg mb-6">
            You don't have permission to access this resource. Please check your account or contact support.
          </p>

          {/* BizHub Branding */}
          <div className="mb-6">
            <p className="text-white/80 text-sm">
              <span className="font-bold text-yellow-300">BizHub</span> - Let's Talk Strategy
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <button
              onClick={handleGoHome}
              className="w-full bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              Go to Dashboard
            </button>
            
            <button
              onClick={handleLogin}
              className="w-full bg-white/20 hover:bg-white/30 text-white font-bold py-3 px-6 rounded-lg transition-all duration-200 border border-white/30"
            >
              Login Again
            </button>

            {/* Auto-redirect countdown */}
            <p className="text-white/70 text-sm">
              Auto-redirecting in {countdown} seconds...
            </p>
          </div>
        </div>

        {/* Support Link */}
        <div className="mt-8 text-white/80 text-sm">
          <p>
            Need access?{' '}
            <a 
              href="mailto:support@letstalkstrategy.io" 
              className="text-yellow-300 hover:text-yellow-400 underline"
            >
              Contact Support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Forbidden;
